export enum Locale {
  EN = "en",
  ES = "es",
  SV = "sv",
  ZU = "zu",
}

export const defaultLocale = Locale.EN;

/**
 * Locales pages are generated for (D-69).
 *
 * `Locale.ZU` is prefixed `/test` (see `localePrefix`) and is not routed at the edge — Fastly
 * carries no `/test` allowlist entry and production answers 404 — so generating it renders and
 * uploads ~25% of every deploy's pages for no consumer. It stays in the enum and in
 * `localePrefix`; it is only excluded from the build set.
 */
export const builtLocales: Locale[] = Object.values(Locale).filter((locale) => locale !== Locale.ZU);
